/**
 * Created by Aleksandr on 28.12.2022
 */

const BlocksOrangery = {
    init: function () {
        this.tabs = [{
            node: this.convertCellToIcon(new Cell({ color: 0 })),
            rows: this.getFormRows()
        }, {
            node: this.convertCellToIcon(new Cell({ color: 0, mark: "goal_blue" })),
            rows: this.getMarksRows()
        }, {
            node: this.convertCellToIcon(new Cell({
                color: 0,
                components: [{
                    "name": "ice",
                    "stage": 0
                }] 
            })),
            rows: this.getComponentsRows()
        }
        ];
    },

    convertCellToIcon: function (cell) {
        const view = new CellView(cell);
        view.setAnchorPoint(0.5, 0.5);
        view.setScale(0.5);
        return view;
    },
    
    getMarksRows: function () {
        const markRows = [[{
            eraser: true,
            itemIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon),
            minimizedIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon)
        }]];

        markRows.push(Object.keys(BlocksGame.MARKS).map((markName) => {
            const cell = new Cell({ color: 0, mark: markName });
            return {
                itemIcon: this.convertCellToIcon(cell),
                minimizedIcon: this.convertCellToIcon(cell),
                form: [
                    "x"
                ],
                color: 0,
                mark: {
                    type: markName
                }
            };
        }));

        const spine1 = new cleverapps.Spine(bundles.blocks.jsons.sigil_rune_json);
        spine1.setAnimation(0, "idle", true);
        const spine2 = new cleverapps.Spine(bundles.blocks.jsons.sigil_rune_json);
        spine2.setAnimation(0, "idle", true);
        markRows[markRows.length - 1].push({
            itemIcon: spine1,
            minimizedIcon: spine2,
            color: -1,
            rune: true
        });
        return markRows;
    },

    getComponentsRows: function () {
        const componentsRows = [[{
            eraser: true,
            itemIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon),
            minimizedIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon)
        }]]; 

        componentsRows.push([{
            name: "ice",
            constructor: IceOnCell
        }].map((component) => {
            const cell = new Cell({
                color: 0,
                components: [{
                    name: component.name
                }]
            });

            return {
                itemIcon: this.convertCellToIcon(cell),
                minimizedIcon: this.convertCellToIcon(cell),
                form: [
                    "x"
                ],
                color: 0,
                components: [{ name: component.name }]
            };
        }));

        return componentsRows;
    },

    getFormRows: function () {
        const formRows = [[{
            eraser: true,
            itemIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon),
            minimizedIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon)
        }], []];
        const formPerRow = 7;

        for (let c = 0; c < BlocksGame.COLORS.length; c++) {
            formRows[1].push({
                color: c,
                itemIcon: this.createTextureByColor(BlocksGame.COLORS[c].rgb),
                minimizedIcon: this.createTextureByColor(BlocksGame.COLORS[c].rgb)
            });
        }

        for (let i = 0; i < Forms.ALL_POSSIBLE_VARIANTS.length; i++) {
            if (i % formPerRow === 0) {
                formRows.push([]);
            }

            const form = Forms.ALL_POSSIBLE_VARIANTS[i];
            const color = i % BlocksGame.COLORS.length;
            const piece = new Piece(undefined, {
                form, color, fromOrangery: true
            });

            const itemIcon = new PieceView(piece, true).view;
            const minimizedIcon = new PieceView(piece, true).view;
            const padding = {
                x: 40,
                y: 40
            };

            cleverapps.UI.wrapWithPadding(itemIcon, padding, true);
            cleverapps.UI.wrapWithPadding(minimizedIcon, padding, true);

            formRows[Math.floor(i / formPerRow) + 2].push({
                form,
                color,
                itemIcon,
                minimizedIcon
            });
        }
        return formRows;
    },

    createTextureByColor: function (color) {
        const colorSprite = new cc.Sprite();
        const w = 60;
        const h = 60;
        
        const texture = new cc.Texture2D();
        const len = w * h * 3;
        const data = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            let colorPart;
            if (i % 3 === 0) {
                colorPart = color.r;
            } else if (i % 3 === 1) {
                colorPart = color.g;
            } else if (i % 3 === 2) {
                colorPart = color.b;
            }

            data[i] = colorPart;
        }
        texture.initWithData(data, cc.Texture2D.PIXEL_FORMAT_RGB888, w, h, w * h);

        colorSprite.initWithTexture(texture, cc.rect(0, 0, w, h));
        return colorSprite;
    },

    getItemCode: function (item) {
        if (item.form) {
            return Forms.ToKey(item.form);
        }
        if (item.color !== undefined) {
            return `Color ${item.color}`;
        }
        return "Eraser";
    }
};
